import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import Areofworks from '../Components/HomeComponent/Areaofservice'
import ProjectShow from '../Components/HomeComponent/projectshowcase'
import PricingPage from '../pages/pricingpage';

const LocationPage = ({ location }) => {
    const seoData = {
        'Gorakhpur': {
            keywords: [
                'web development company in Gorakhpur',
                'app developers UP',
                'best software company eastern UP',
                'React.js development Gorakhpur',
                'digital solutions UP',
                'mobile app company Gorakhpur',
                'website design UP'
            ],
            metaDesc: 'Leading web and app development company in Gorakhpur. Expert React.js, mobile app & custom software development services.',
            address: 'Noida, Uttar Pradesh, India'
        },
        'Delhi': {
            keywords: [
                'top tech company Delhi NCR',
                'custom software development Delhi',
                'enterprise solutions Delhi',
                'mobile app developers Delhi',
                'web application Delhi',
                'IT consulting Delhi',
                'digital transformation Delhi'
            ],
            metaDesc: 'Premier software development company in Delhi NCR. Specialized in enterprise solutions, mobile apps & web development.',
            address: 'Delhi NCR, India'
        }
        // Add other locations similarly
    };

    const currentSEO = seoData[location] || {
        keywords: [],
        metaDesc: `Leading tech solutions provider in ${location}`,
        address: `${location}, India`
    };

    const projects = [
        {
            title: "E-commerce Revolution",
            client: "FashionHub",
            category: "E-commerce",
            stats: {
                growth: "200%",
                users: "50K+",
                revenue: "₹2Cr+"
            },
            description: "Transformed traditional retail business into a thriving online marketplace",
            features: ["Custom CMS", "Payment Gateway", "Real-time Analytics"],
            image: "/api/placeholder/600/400"
        },
        {
            title: "HealthTech Platform",
            client: "MediCare Plus",
            category: "Healthcare",
            stats: {
                appointments: "100K+",
                doctors: "500+",
                satisfaction: "98%"
            },
            description: "Built comprehensive healthcare management system",
            features: ["Appointment Booking", "Patient Records", "Telemedicine"],
            image: "/api/placeholder/600/400"
        },
        {
            title: "Learning Management",
            client: "EduTech",
            category: "Education",
            stats: {
                students: "25K+",
                courses: "200+",
                completion: "95%"
            },
            description: "Developed interactive learning platform for remote education",
            features: ["Live Classes", "Progress Tracking", "Interactive Quizzes"],
            image: "/api/placeholder/600/400"
        }
    ];

    const fadeInUp = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 }
    };



    return (
        <>

            <Helmet>
                <title>Top Tech Solutions in {location} | Vibhraad</title>
                <meta name="description" content={`Leading software development company in ${location}. Expert web & app development, 24/7 support, best-in-class solutions.`} />
                <meta name="keywords" content={`software development ${location}, web development, app development, IT services ${location}, tech solutions ${location}`} />
            </Helmet>

            {/* Hero Section */}
            <motion.section
                className="relative h-[80vh]  bg-gradient-to-r from-black via-gray-900 to-black text-white"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
            >
                <div className="container  justify-center mx-auto px-4 h-full flex items-center">
                    <motion.div
                        className="max-w-3xl"
                        variants={fadeInUp}
                    >
                        <h1 className="text-5xl md:text-7xl text-center font-bold mb-6">
                            Transform Your Business in <span className="text-blue-600">{location}</span>
                        </h1>
                        <p className="text-xl text-center md:text-2xl mb-8">
                            Cutting-edge web & mobile solutions tailored for your success
                        </p>

                    </motion.div>
                </div>
            </motion.section>





            {/* Stats Section */}
            <motion.section
                className="py-20 bg-white"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
            >
                <div className="container mx-auto px-4">
                    <div className="grid md:grid-cols-4 gap-8 text-center">
                        {[
                            { number: "100+", label: "Projects Delivered" },
                            { number: "50+", label: `Clients in ${location}` },
                            { number: "24/7", label: "Support Available" },
                            { number: "98%", label: "Client Satisfaction" }
                        ].map((stat, index) => (
                            <motion.div
                                key={index}
                                className="p-6 "
                                whileHover={{ y: -5 }}
                            >
                                <h3 className="text-6xl font-bold text-black">{stat.number}</h3>
                                <p className=" font-medium text-2xl text-black">{stat.label}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </motion.section>

            {/* <ProjectShow /> */}




            <Areofworks />

            {/* Common Queries Section */}


            {/* CTA Section */}
            {/* <motion.section
                className="py-20 bg-white text-white text-center"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
            >
                <div className="container mx-auto px-4">
                    <h2 className="text-4xl font-bold mb-8">Start Your Digital Journey Today</h2>
                    <p className="text-xl mb-8">Get a free consultation and cost estimate for your project</p>
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className="bg-blue-600 text-black px-8 py-4 rounded-full text-xl font-bold"
                    >
                        Schedule a Call
                    </motion.button>
                </div>
            </motion.section> */}

            <Helmet>
                <title>Vibhraad - Tech Solutions in {location}</title>
                <meta name="description" content={currentSEO.metaDesc} />
                <meta name="keywords" content={currentSEO.keywords.join(', ')} />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "SoftwareCompany",
                        "name": "Vibhraad",
                        "description": currentSEO.metaDesc,
                        "address": {
                            "@type": "PostalAddress",
                            "addressLocality": location,
                            "addressRegion": currentSEO.address
                        }
                    })}
                </script>
            </Helmet>

            <PricingPage />
            <section className="py-20 bg-gradient-to-b from-black to-gray-900">
                <div className="container mx-auto px-4">
                    <motion.h2
                        className="text-4xl md:text-6xl text-white font-bold mb-16 text-center"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        Success Stories in <span className="text-blue-600">{location}</span>
                    </motion.h2>

                    <div className="grid lg:grid-cols-3 gap-8">
                        {projects.map((project, index) => (
                            <motion.div
                                key={index}
                                className="bg-white rounded-2xl overflow-hidden shadow-2xl"
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.2 }}
                                viewport={{ once: true }}
                                whileHover={{ y: -10 }}
                            >
                                <div className="relative">
                                    <img
                                        src={project.image}
                                        alt={project.title}
                                        className="w-full h-48 object-cover"
                                    />
                                    <div className="absolute top-4 right-4 bg-blue-600 text-black px-4 py-1 rounded-full text-sm font-bold">
                                        {project.category}
                                    </div>
                                </div>

                                <div className="p-6">
                                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{project.title}</h3>
                                    <p className="text-gray-600 mb-4">{project.description}</p>

                                    <div className="grid grid-cols-3 gap-4 mb-6">
                                        {Object.entries(project.stats).map(([key, value], i) => (
                                            <motion.div
                                                key={i}
                                                className="text-center p-2 bg-gray-50 rounded-lg"
                                                whileHover={{ scale: 1.05 }}
                                            >
                                                <div className="text-blue-600 font-bold text-xl">{value}</div>
                                                <div className="text-gray-500 text-sm">{key}</div>
                                            </motion.div>
                                        ))}
                                    </div>

                                    <div className="space-y-2">
                                        {project.features.map((feature, i) => (
                                            <div key={i} className="flex items-center text-gray-700">
                                                <motion.div
                                                    className="w-2 h-2 bg-blue-600 rounded-full mr-2"
                                                    initial={{ scale: 0 }}
                                                    whileInView={{ scale: 1 }}
                                                    viewport={{ once: true }}
                                                />
                                                {feature}
                                            </div>
                                        ))}
                                    </div>

                                    <motion.button
                                        className="mt-6 w-full bg-white text-white py-3 rounded-lg font-bold hover:bg-gray-800 transition-colors"
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                    >
                                        View Case Study
                                    </motion.button>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default LocationPage;